import { render } from "./common-avatar.vue?vue&type=template&id=24ccd146&ts=true"
import script from "./common-avatar.vue?vue&type=script&lang=ts"
export * from "./common-avatar.vue?vue&type=script&lang=ts"

import "./common-avatar.vue?vue&type=style&index=0&id=24ccd146&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__